// src/App.tsx
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChakraProvider, useColorMode, DarkMode } from "@chakra-ui/react";
import { Route, Routes, useParams } from "react-router-dom";
import PublicLayout from "./layouts/PublicLayout";
import PrivateLayout from "./layouts/PrivateLayout";
import Home from "./pages/Home";
import Pricing from "./pages/Pricing";
import Presentation from "./pages/Presentation";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import Subscribe from "./pages/Subscribe";
import Account from "./pages/Account";
import PrivateRoute from "./components/PrivateRoute";
import ViewProject from "./components/ViewProject";
import PublicRoute from "./components/PublicRoute";
import themeAdmin from "./theme/themeAdmin";
import themePublic from "./theme/themePublic";
import CreateProject from "./components/CreateProject";
import "./App.css";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import Authorize from "./pages/Authorize";
import Authorization from "./pages/Authorization";
import Admin from "./pages/Admin";
import AdminRoute from "./components/AdminRoute";
import { ConfigProvider } from "./context/ConfigContext";
import { ImpersonationProvider } from "./context/ImpersonationContext";

function App() {
  const [projectName, setProjectName] = useState<string>("Projet");
  const { projectId } = useParams<{ projectId: string }>();
  const { t } = useTranslation();

  const { setColorMode } = useColorMode();

  setColorMode("dark");

  return (
    <ConfigProvider>
      <ImpersonationProvider>
      <Routes>
        {/* Routes publiques avec le layout public */}

      <Route
        path="/"
        element={
          <PublicRoute>
            <ChakraProvider theme={themePublic}>
              <PublicLayout>
                <Login />
              </PublicLayout>
            </ChakraProvider>
          </PublicRoute>
        }
      />
      <Route
        path="/login"
        element={
          <PublicRoute>
            <ChakraProvider theme={themePublic}>
              <PublicLayout>
                <Login />
              </PublicLayout>
            </ChakraProvider>
          </PublicRoute>
        }
      />
      <Route
        path="/signup"
        element={
          <PublicRoute>
            <ChakraProvider theme={themePublic}>
              <PublicLayout>
                <Signup />
              </PublicLayout>
            </ChakraProvider>
          </PublicRoute>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <PublicRoute>
            <ChakraProvider theme={themePublic}>
              <PublicLayout>
                <ForgotPassword />
              </PublicLayout>
            </ChakraProvider>
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute>
            <ChakraProvider theme={themePublic}>
              <DarkMode>
                <Register />
              </DarkMode>
            </ChakraProvider>
          </PublicRoute>
        }
      />
      {/* Routes privées avec le layout privé */}
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <ChakraProvider theme={themeAdmin}>
              <PrivateLayout>
                <Dashboard />
              </PrivateLayout>
            </ChakraProvider>
          </PrivateRoute>
        }
      />{" "}
      <Route
        path="/create"
        element={
          <PrivateRoute>
            <ChakraProvider theme={themeAdmin}>
              <PrivateLayout>
                <CreateProject />
              </PrivateLayout>
            </ChakraProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/account"
        element={
          <PrivateRoute>
            <ChakraProvider theme={themeAdmin}>
              <PrivateLayout>
                <Account />
              </PrivateLayout>
            </ChakraProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/subscribe"
        element={
          <PrivateRoute>
            <ChakraProvider theme={themeAdmin}>
              <PrivateLayout>
                <Subscribe />
              </PrivateLayout>
            </ChakraProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/projects/:projectId"
        element={
          <PrivateRoute>
            <ChakraProvider theme={themeAdmin}>
              <PrivateLayout>
                <ViewProject setProjectName={setProjectName} />
              </PrivateLayout>
            </ChakraProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/folder/:projectFolderId"
        element={
          <PrivateRoute>
            <ChakraProvider theme={themeAdmin}>
              <PrivateLayout>
                <Dashboard />
              </PrivateLayout>
            </ChakraProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/authorize"
        element={
          <PrivateRoute>
            <ChakraProvider theme={themeAdmin}>
              <PrivateLayout>
                <Authorize />
              </PrivateLayout>
            </ChakraProvider>
          </PrivateRoute>
        }
      />    <Route
        path="/authorization"
        element={
          <PrivateRoute>
            <ChakraProvider theme={themeAdmin}>
              <PrivateLayout>
                <Authorization />
              </PrivateLayout>
            </ChakraProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <AdminRoute>
            <ChakraProvider theme={themeAdmin}>
              <PrivateLayout>
                <Admin />
              </PrivateLayout>
            </ChakraProvider>
          </AdminRoute>
        }
      />
      </Routes>
      </ImpersonationProvider>
    </ConfigProvider>
  );
}

export default App;
